import { useCallback, useState } from 'react';

export function shouldCloseTechnicianMenuOnOutsideClick(event, showTechnicianMenu) {
  const hasOpen = Object.values(showTechnicianMenu || {}).some(Boolean);
  if (!hasOpen) return false;
  return (
    !event.target.closest('.technician-menu-modal')
    && !event.target.closest('.technician-menu-container')
  );
}

export function useTechnicianMenu() {
  const [showTechnicianMenu, setShowTechnicianMenu] = useState({});
  const [technicianMenuPrevisaoOpen, setTechnicianMenuPrevisaoOpen] = useState(null);
  const [technicianMenuPositions, setTechnicianMenuPositions] = useState({});

  const closeAllTechnicianMenus = useCallback(() => {
    setShowTechnicianMenu({});
    setTechnicianMenuPrevisaoOpen(null);
  }, []);

  const toggleTechnicianMenu = useCallback((technician) => {
    setShowTechnicianMenu((prev) => ({
      ...prev,
      [technician]: !prev[technician],
    }));
  }, []);

  const updateTechnicianMenuPosition = useCallback((technician, newPosition) => {
    setTechnicianMenuPositions((prev) => {
      const currentPosition = prev[technician];
      if (
        !currentPosition
        || Math.abs(currentPosition.top - newPosition.top) > 1
        || Math.abs(currentPosition.left - newPosition.left) > 1
      ) {
        return {
          ...prev,
          [technician]: newPosition,
        };
      }
      return prev;
    });
  }, []);

  return {
    showTechnicianMenu,
    setShowTechnicianMenu,
    technicianMenuPrevisaoOpen,
    setTechnicianMenuPrevisaoOpen,
    technicianMenuPositions,
    setTechnicianMenuPositions,
    closeAllTechnicianMenus,
    toggleTechnicianMenu,
    updateTechnicianMenuPosition,
  };
}
